import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import "./LegalPages.css";

const CookiePolicy = () => {
  return (
    <div className="legal-page">
      <SEO
        title="Cookie Policy | Lubrichem"
        description="Understand how Lubrichem uses cookies to improve your browsing experience."
        url="https://yourdomain.com/cookie-policy"
      />

      <section className="legal-hero">
        <div className="container text-center">
          <h1>Cookie Policy</h1>
          <p>How we use cookies on our website.</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-card">
            <p className="updated">Last updated: March 2025</p>

            <h3>1. What Are Cookies?</h3>
            <p>
              Cookies are small text files stored on your device when you visit
              a website. They help improve functionality and user experience.
            </p>

            <h3>2. How We Use Cookies</h3>
            <ul>
              <li>To analyze website traffic and usage</li>
              <li>To remember user preferences</li>
              <li>To improve website performance</li>
            </ul>

            <h3>3. Types of Cookies We Use</h3>
            <ul>
              <li>
                <strong>Essential Cookies:</strong> Required for core website
                functionality
              </li>
              <li>
                <strong>Analytics Cookies:</strong> Help us understand how users
                interact with our site
              </li>
              <li>
                <strong>Functional Cookies:</strong> Remember user preferences
              </li>
            </ul>

            <h3>4. Managing Cookies</h3>
            <p>
              You can control or delete cookies through your browser settings.
              Disabling cookies may affect website functionality.
            </p>

            <h3>5. Third-Party Cookies</h3>
            <p>
              Some cookies may be placed by third-party services such as
              analytics tools. We do not control these cookies.
            </p>

            <h3>6. Updates to This Policy</h3>
            <p>
              We may update this Cookie Policy periodically. Any changes will be
              posted on this page.
            </p>

            <h3>7. Contact Us</h3>
            <p>
              For questions about our Cookie Policy, please contact us via our{" "}
              <Link to="/contact">Contact Page</Link>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
